/* istanbul ignore file */
export default [
  {
    path: '/bcm/constructs',
    name: 'bcmConstructs',
    component: () => import('../views/BcmConstructFrameworks'),
    props: true,
    meta: {
      auth: true
    }
  },
  {
    path: '/bcm/constructs/details/:id',
    name: 'bcmConstructProfile',
    component: () => import('../views/BcmConstructProfile'),
    props: true,
    meta: {
      auth: true
    }
  },
  {
    path: '/bcm',
    name: 'bcmExplore',
    component: () => import('../views/BcmExplore'),
    props: true,
    meta: {
      auth: true
    }
  },
  {
    path: '/bcm/tasks',
    name: 'bcmTasks',
    component: () => import('../views/BcmTasks'),
    props: true,
    meta: {
      auth: true
    }
  },
  {
    path: '/bcm/tasks/details/:id',
    name: 'bcmTaskProfile',
    component: () => import('../views/BcmTaskProfile'),
    props: true,
    meta: {
      auth: true
    }
  },
  {
    path: '/bcm/items',
    name: 'bcmItems',
    component: () => import('../views/BcmItems'),
    props: true,
    meta: {
      auth: true
    }
  },
  {
    path: '/bcm/items/details/:id',
    name: 'bcmItemProfile',
    component: () => import('../views/BcmItemProfile'),
    props: true,
    meta: {
      auth: true
    }
  },
  {
    path: '/bcm/matrices',
    name: 'bcmMatrices',
    component: () => import('../views/BcmMatrices'),
    props: true,
    meta: {
      auth: true
    }
  },
  {
    path: '/bcm/models',
    name: 'bcmModels',
    component: () => import('../views/BcmModels'),
    props: true,
    meta: {
      auth: true
    }
  }
]
